module.exports = __webpack_public_path__ + "static/media/DWK_05.4a472d7f.jpg";